var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaxes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 56,
    viewBox: "0 0 66 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8763_27951)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8763_27951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.416 16.0045C39.312 15.1085 40.7653 15.1072 41.6613 16.0045C42.5573 16.9005 42.5573 18.3539 41.6613 19.2499L31.296 29.6085C31.0453 29.8579 30.7067 29.9992 30.3533 29.9992H27.6667V27.3125C27.6667 26.9592 27.8067 26.6205 28.0573 26.3699L38.416 16.0045Z",
    stroke: "#4F5B6F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 30H39.6667",
    stroke: "#4F5B6F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3333 35.332H39.6667",
    stroke: "#4F5B6F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3333 26C43.8067 26 45 27.1933 45 28.6667V38C45 39.4733 43.8067 40.6667 42.3333 40.6667H23.6667C22.1933 40.6667 21 39.4733 21 38V28.6667C21 27.1933 22.1933 26 23.6667 26",
    stroke: "#4F5B6F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7573 18.6641L39 21.9067",
    stroke: "#4F5B6F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4213 19.4198L32.6093 17.2318C33.2413 16.5998 34.2667 16.5998 34.9 17.2318C35.532 17.8638 35.532 18.8891 34.9 19.5225L33.3787 21.0438",
    stroke: "#4F5B6F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8763_27951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(17 12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8763_27951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(17 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxes);
export default __webpack_public_path__ + "static/media/taxes.66a7bc5d667b0210147a376070cd2b82.svg";
export { ForwardRef as ReactComponent };